import { createFeatureSelector, createSelector } from '@ngrx/store';
import { commonIdFindUniversityFeatureKey, State } from '../../reducers/common-id/common-id-find-university.reducer';

const selectFindUniversityState = createFeatureSelector<State>(commonIdFindUniversityFeatureKey);

export const getFindUniversityResult = createSelector(selectFindUniversityState, state => state.result);
